// extracted by mini-css-extract-plugin
export var actionButton = "_ik-0";
export var fileInput = "_ik-2";
export var paperclip = "_ik-1";